import React from 'react'
import './AdminInquiryDetail.css'

const AdminInquiryDetail = () => {
  return (
    <div className="admin-inquiry-detail">
      <section className="ad-inquiry-d-section-01">
        <ul>
          <li>
            <span>문의 제목</span>
            <span>문의제목</span>
          </li>
          <li>
            <span>작성자</span>
            <span>홍길동</span>
          </li>
          <li>
            <span>문의일시</span>
            <span>2000-00-00</span>
          </li>
          <li>
            <span>문의내용</span>
            <p>
              문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
              내용문의 내용
            </p>
          </li>
        </ul>
      </section>
      <section className="ad-inquiry-d-section-02">
        <div className="ad-inquiry-d--header">답변 내용</div>
        <div className="ad-inquiry-d--content">
          <textarea>
            문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
            내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
            내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
            내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
            내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
            내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
            내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
            내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
            내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
            내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
            내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
            내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
            내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
            내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
            내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
            내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의
            내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용문의 내용
          </textarea>
        </div>
      </section>
      <div className="admin-edit-button">
        <button>취소</button>
        <button>저장</button>
      </div>
    </div>
  )
}
export default AdminInquiryDetail
